angular.module('env.customConfig.directives', [
    'env.customConfig.provider',
    'env.customConfig.logicResolvers',
    'env.custom.customModule'
])
    .config(function ($customisationConfigProvider, $customLogicResolversProvider) {
        $customisationConfigProvider.directives =
            [
                {
                    name: "hello-directive",
                    options: [
                        {
                            value: "hello-alice",
                            condition: function (context) { // can return string or boolean
                                return context.user.name == 'Alice';
                            }
                        },
                        {
                            value: "hello-bob",
                            condition: function (context) {
                                return context.user.name == 'Bob';
                            }
                        },
                        {
                            value: "hello-mark",
                            condition: function (context) {
                                return context.user.name == 'Mark';
                            }
                        }
                    ]
                },
                {},
                {}
            ];
    })
;
